// libs
import 'lodash';

import 'angular/angular';
import 'angular-resource/angular-resource';
import 'angular-cache/dist/angular-cache';
import 'angular-i18n/angular-locale_de-de.js';
import 'angular-q-spread/dist/q-spread';
import 'angular-bind-notifier/dist/angular-bind-notifier';
import 'angular-media-queries/match-media';
import 'restangular/dist/restangular';

import 'moment/locale/de';
import 'moment-duration-format';

import 'script!lib/angular-messages/angular-messages';
import 'script!lib/angular-translate/angular-translate';
import 'script!lib/angular-translate-loader-static-files/angular-translate-loader-static-files';
import 'script!lib/angular-animate/angular-animate';
import 'script!lib/angular-sanitize/angular-sanitize';
import 'script!lib/angular-ui-router/release/angular-ui-router';
import 'script!lib/ionic/js/ionic';
import 'script!lib/ionic/js/ionic-angular';

//import 'script!lib/angular-fast-repeat/dist/fastRepeat.min.js';
//import 'script!lib/quick-ng-repeat/quick-ng-repeat';
//import 'script!lib/ionic-scroll-sista/ionic-scroll-sista'

// app
import './app';





// WEBPACK FOOTER //
// ./src/index.js